export default __webpack_public_path__ + "static/media/icoExcelDorado.7af08250.svg";